// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__23HMU","title":"ClientReferral_title__1WPlu","itemText":"ClientReferral_itemText__3Rn1z"};